'use client'
import { T } from '@/components/t'
import { RestaurantCitySeoDescription } from '@/features/restaurants/restaurants-city-search/restaurant-city-seo-description'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'
import { SvgMapNeedle } from '@/icons/svg-map-needle'
import { cn } from '@/utils/styles/cn'

interface IRestaurantsCityHeaderProps {
    citySlug: string
}

export const RestaurantsCityHeader = ({ citySlug }: IRestaurantsCityHeaderProps) => {
    const { city } = useRestaurantCitySearchContext()

    return (
        <div className="w-full flex items-center justify-center px-4 md:px-0">
            <div className="flex flex-col items-center" style={{ maxWidth: 'min(1183px, 80vw)' }}>
                <div className="hidden md:flex flex-row items-center gap-4 mb-1">
                    <T
                        h1
                        t={['restaurants.city.restaurantsIn', { cityName: city?.name ?? '' }]}
                        className={cn('text-[48px] font-bold')}
                    />
                    <SvgMapNeedle color="none" size={33} />
                </div>

                <RestaurantCitySeoDescription citySlug={citySlug} className="md:block hidden" />
            </div>
        </div>
    )
}
